import * as React from "react";

const FormSearch: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.996 15" fill="currentColor">
            <path
                fill="#75B8C8"
                d="m14.769 13.799-3.926-3.926c.85-1.04 1.318-2.35 1.318-3.78A6.093 6.093 0 0 0 6.067 0C2.702 0 0 2.728 0 6.094c0 3.365 2.728 6.093 6.067 6.093 1.43 0 2.741-.495 3.78-1.319l3.925 3.926a.81.81 0 0 0 .525.206c.179 0 .36-.069.497-.206a.685.685 0 0 0-.025-.995ZM1.406 6.094a4.693 4.693 0 0 1 4.688-4.688 4.693 4.693 0 0 1 4.687 4.688 4.693 4.693 0 0 1-4.687 4.687 4.693 4.693 0 0 1-4.688-4.687Z"
            />
        </svg>
    );
};

export default React.memo(FormSearch);
